<template>
  <ul id="navigation">
    <li id="nav-about-li">
      <router-link to="/About">
        <img src="./assets/images/nav-about-icon.png" alt="" srcset="" />
        <span> درباره </span>
      </router-link>
    </li>
    <li>
      <router-link to="/skills">
        <img src="./assets/images/nav-about-icon.png" alt="" srcset="" />
        <span> مهارت ها </span>
      </router-link>
    </li>
    <li>
      <router-link to="/Projects">
        <img src="./assets/images/nav-about-icon.png" alt="" srcset="" />
        <span>نمونه کار ها</span>
      </router-link>
    </li>
    <li>
      <router-link to="/Experience">
        <img src="./assets/images/nav-about-icon.png" alt="" srcset="" />
        <span>سابقه کار</span>
      </router-link>
    </li>
    <li>
      <router-link to="/Achievement">
        <img src="./assets/images/nav-about-icon.png" alt="" srcset="" />
        <span>دستاورد ها</span>
      </router-link>
    </li>
  </ul>
  <div id="main-info">
    <div id="main-info-images">
      <img :alt="info.name" :src="info.banner" />
      <img :src=" info.profile" :alt="info.name" />
    </div>
    <h2 id="name">{{ info.name }}</h2>
    <p id="min-about" style="text-align : center;color : #ededed">
      {{ info.bio }}
    </p>
    <div id="main-info-social-icons" >
      
      <a :key="index" v-for="(item,index) in socials" :href="item.link">
        
        <img alt="محمد رستمی" style="width : 40px;height: 40px;display : inline-block" :src="item.icon"  srcset="" />
      </a>
    </div>
  </div>
  <div id="router-view">
    <router-view></router-view>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      info: {},
      socials: {},
    };
  },
  mounted() {
    axios
      .post("https://mohammadrostamidevapi.iran.liara.run/api/v1/mainInfo", {})
      .then((respose) => (this.info = respose.data))
      .then((error) => console.log(error));
    // console.log(this.info)
    axios
      .post("https://mohammadrostamidevapi.iran.liara.run/api/v1/socials")
      .then((respose) => (this.socials = respose.data))
      .then((error) => console.log(error));
      console.log(this.socials)
  },
};
</script>

<style>
@font-face {
  font-family: iransans;
  src: url(assets/fonts/AIranianSans.ttf);
}
</style>
